export enum TimeslotListVariantEnum {
  EXTENDED = 'extended',
  SHORT = 'short',
}
